<template>
  <div class="supervising-teacher-dialog">
    <el-dialog :title="'上级教师：' + teacherInfo.teacherName" :visible.sync="supervisingTeacherDialogShow" width="750px"
      :before-close="dialogClose" @open="dialogOpen">
      <el-transfer class="btn-list" filterable filter-placeholder="请输入教师姓名" v-model="selectTeacherList"
        :data="superiorsTeacherList" :props="{
          key: 'id',
          label: 'teacherName',
        }" :titles="['未选择', '已选择']"></el-transfer>
      <div class="btn-list">
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'supervisingTeacherDialogShow',
    'teacherInfo',
    'superiorsTeacherList',
    'teacherAllotByTeacherList'
  ],
  data() {
    return {
      selectTeacherList: []
    };
  },
  methods: {
    // 开启弹窗
    dialogOpen() {
      this.selectTeacherList = [];
      if(!this.teacherAllotByTeacherList) return;
      this.teacherAllotByTeacherList.forEach(item => {
        if (this.selectTeacherList.includes(item.teacherId)) return;
        this.selectTeacherList.push(item.teacherId)
      }
      );
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:supervisingTeacherDialogShow", false);
    },
    submit() {
      let data = {
        "teacherId": this.teacherInfo.id,
        "mentorId": this.selectTeacherList
      };
      this.$emit("submit", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./supervisingTeacherDialog.scss";
</style>